import React from 'react';
import { motion } from 'framer-motion';
import { HiHome, HiArrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import './NotFound.scss';

const NotFound = () => {
  return (
    <div className="app__not-found">
      <motion.div
        className="app__not-found-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          className="app__not-found-number"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          404
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          Oops! Page Not Found
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          The page you're looking for doesn't exist or has been moved.
          <br />
          Let's get you back on track!
        </motion.p>
        
        <motion.div
          className="app__not-found-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <Link 
            to="/" 
            className="app__not-found-btn primary"
          >
            <HiHome />
            Go Home
          </Link>
          
          <button 
            onClick={() => {
              window.history.back();
            }}
            className="app__not-found-btn secondary"
          >
            <HiArrowLeft />
            Go Back
          </button>
        </motion.div>
        
        <motion.div
          className="app__not-found-suggestions"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1 }}
        >
          <h3>You might be looking for:</h3>
          <div className="suggestions-list">
            <Link 
              to="/" 
              className="suggestion-item"
            >
              Portfolio
            </Link>
            <Link 
              to="/chat" 
              className="suggestion-item"
            >
              Chat with AI
            </Link>
            <Link 
              to="/#about" 
              className="suggestion-item"
            >
              About
            </Link>
            <Link 
              to="/#skills" 
              className="suggestion-item"
            >
              Skills
            </Link>
            <Link 
              to="/#work" 
              className="suggestion-item"
            >
              Projects
            </Link>
          </div>
        </motion.div>
      </motion.div>
      
      {/* Animated background elements */}
      <div className="app__not-found-bg">
        <motion.div
          className="bg-circle circle-1"
          animate={{
            x: [0, 30, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="bg-circle circle-2"
          animate={{
            x: [0, -40, 0],
            y: [0, 40, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="bg-circle circle-3"
          animate={{
            x: [0, 20, 0],
            y: [0, -20, 0],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>
    </div>
  );
};

export default NotFound; 